'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _Viewport = require('../../modules/Viewport');

var mapStateToProps = function mapStateToProps(state) {
    return {
        viewport: (0, _Viewport.selectViewportScreenSizeAndOrientation)(state),
        isMobile: (0, _Viewport.selectIsMobile)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps);